angular.module('common', [
  'toastr',
  'ui.select',
  'pascalprecht.translate',
  'ngFileUpload',
  'angular-storage',
  'common-config'
]);
